export const ORBIT_CENTER = { x: 20, y: 14 }

export const SPARKLES_CSS = (uid: string) => `
  @keyframes kenneth-wand-wave {
    0%, 100% { transform: translateY(0); }
    50%       { transform: translateY(-0.6px); }
  }

  @keyframes kenneth-hat-star-orbit {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }

  @keyframes kenneth-wand-star-1 {
    0%   { transform: translate(0, 0) scale(1); opacity: 1; }
    30%  { transform: translate(0.8px, -1.2px) scale(1.3); opacity: 0.8; }
    60%  { transform: translate(-0.5px, -0.4px) scale(0.7); opacity: 1; }
    100% { transform: translate(0, 0) scale(1); opacity: 1; }
  }

  @keyframes kenneth-wand-star-2 {
    0%   { transform: translate(0, 0) scale(1); opacity: 0.9; }
    25%  { transform: translate(-1px, -0.6px) scale(0.8); opacity: 1; }
    55%  { transform: translate(0.4px, -1.4px) scale(1.2); opacity: 0.7; }
    80%  { transform: translate(-0.3px, 0.5px) scale(1); opacity: 1; }
    100% { transform: translate(0, 0) scale(1); opacity: 0.9; }
  }

  @keyframes kenneth-wand-star-3 {
    0%   { transform: translate(0, 0) scale(1.1); opacity: 1; }
    40%  { transform: translate(0.6px, 0.8px) scale(0.75); opacity: 0.6; }
    70%  { transform: translate(-0.9px, -0.3px) scale(1.2); opacity: 1; }
    100% { transform: translate(0, 0) scale(1.1); opacity: 1; }
  }

  @keyframes kenneth-wand-star-4 {
    0%   { transform: translate(0, 0) scale(0.9); opacity: 0.8; }
    20%  { transform: translate(1.1px, -0.5px) scale(1.1); opacity: 1; }
    50%  { transform: translate(0.2px, 0.9px) scale(0.8); opacity: 0.7; }
    75%  { transform: translate(-0.7px, -1px) scale(1.15); opacity: 1; }
    100% { transform: translate(0, 0) scale(0.9); opacity: 0.8; }
  }

  #kenneth-wand-${uid} {
    transform-box: fill-box;
    transform-origin: 50% 100%;
    animation: kenneth-wand-wave 1.8s ease-in-out infinite;
  }

  #kenneth-wand-star-1-${uid} {
    transform-box: fill-box;
    transform-origin: 50% 50%;
    animation: kenneth-wand-star-1 2.3s ease-in-out infinite;
  }

  #kenneth-wand-star-2-${uid} {
    transform-box: fill-box;
    transform-origin: 50% 50%;
    animation: kenneth-wand-star-2 1.9s ease-in-out infinite;
    animation-delay: -0.7s;
  }

  #kenneth-wand-star-3-${uid} {
    transform-box: fill-box;
    transform-origin: 50% 50%;
    animation: kenneth-wand-star-3 2.7s ease-in-out infinite;
    animation-delay: -1.1s;
  }

  #kenneth-wand-star-4-${uid} {
    transform-box: fill-box;
    transform-origin: 50% 50%;
    animation: kenneth-wand-star-4 2.1s ease-in-out infinite;
    animation-delay: -0.4s;
  }

  #kenneth-hat-stars-${uid} .star-a {
    transform-box: view-box;
    transform-origin: ${ORBIT_CENTER.x}px ${ORBIT_CENTER.y}px;
    animation: kenneth-hat-star-orbit 4s linear infinite;
  }

  #kenneth-hat-stars-${uid} .star-b {
    transform-box: view-box;
    transform-origin: ${ORBIT_CENTER.x}px ${ORBIT_CENTER.y}px;
    animation: kenneth-hat-star-orbit 4s linear infinite;
    animation-delay: -1.33s;
  }

  #kenneth-hat-stars-${uid} .star-c {
    transform-box: view-box;
    transform-origin: ${ORBIT_CENTER.x}px ${ORBIT_CENTER.y}px;
    animation: kenneth-hat-star-orbit 4s linear infinite;
    animation-delay: -2.67s;
  }
`
